<!-- 企业文化 -->
<template>
    <div>
      <!-- <div class="header_img"></div> -->
       <sub-banner id="id_about">        
           <img src="../../assets/images/corporateCulture/corporate.jpg"/>

      </sub-banner>

      <div class="culture_info">
          <div class="culture_content">
              <div class="title_s">{{$t('NavabarText.team_culture')}}</div>
              <div class="title_descript">{{$t('NavabarText.team_culture_desc')}}</div>
              <div class="culture_team">
                  <div class="team_content">
                      <div class="team_item" v-for="(item,index) in teamItemList" :key="item.id" :class="item.hidden==true?'team_item_hidden':''" @click="watchDetail(item)">
                          <div class="item_img">
                              <img :src="item.synopsisImg"/>
                          </div>
                          <div class="item_desc">{{item.articleAbstract}}</div>
                         <div class="item_detail">
                              <div class="detail_btn" @click="watchDetail(item)">查看详情</div>
                          </div>
                      </div>
                  </div>
                  <div class="arrow_left" id="left" @click="leftClick">
                     <span class="icon iconfont icon-zuojiantou1"></span>
                  </div>
                  <div class="arrow_right" id="right" @click="rightClick">
                     <span class="icon iconfont icon-iconfontjiantouyou"></span>
                  </div>
              </div>
          </div>
          
      </div>
      <div class="company_culture_info" :class="$store.state.lang=='en-US'?'eng_company_culture_info':''">
          <div class="company_culture_content">
              <div class="company_culture_title">{{$t('NavabarText.navbr_child_about_3')}}</div>
              <div class="company_culture_desc">{{$t('NavabarText.company_culture_desc')}}</div>
              <div class="company_content_culture">
                  <div class="culture_item">
                      <div class="culture_item_img">
                          <img src="../../assets/images/corporateCulture/culture_one.png" />
                      </div>
                      <div class="item_titles">{{$t('corporate.item_1')}}</div>
                      <div class="item_descs">{{$t('corporate.item_1_desc')}}</div>
                  </div>
                  <div class="culture_item">
                      <div class="culture_item_img">
                          <img src="../../assets/images/corporateCulture/culture_three.png" />
                      </div>
                      <div class="item_titles">{{$t('corporate.item_2')}}</div>
                      <div class="item_descs">{{$t('corporate.item_2_desc')}}</div>
                  </div>
                  <div class="culture_item">
                      <div class="culture_item_img">
                          <img src="../../assets/images/corporateCulture/culture_four.png" />
                      </div>
                      <div class="item_titles">{{$t('corporate.item_3')}}</div>
                      <div class="item_descs">{{$t('corporate.item_3_desc')}}</div>
                  </div>
                  <div class="culture_item">
                      <div class="culture_item_img">
                          <img src="../../assets/images/corporateCulture/culture_one.png" />
                      </div>
                      <div class="item_titles">{{$t('corporate.item_4')}}</div>
                      <div class="item_descs">{{$t('corporate.item_4_desc')}}</div>
                  </div>
              </div>
          </div>
      </div>
    </div>
</template>

<script>
import SubBanner from "@/components/sub-banner";

import {getArticleByTypeList} from '../../service/service'
export default {
  name: 'concat',
  metaInfo () {
    return {
      title: this.pageTitle,
      meta:[{
        name:this.metaName,
        content:this.metaContent,
        keyword:this.keyword,
        description:this.description
      }]
    }
  },
  components: {SubBanner},
  data () {
    return {
      pageTitle: '广州市熵达贸易有限公司-企业文化',
      metaName:'广州市熵达贸易有限公司-企业文化',
      metaContent:'广州市熵达贸易有限公司-企业文化',
      keyword:'广州市熵达贸易有限公司,',
      description:'广州市熵达贸易有限公司' ,   
      form: {
        code: '',
        name: '',
        phone: '',
        needContent:'',
      },
      team_item_left_index:0,
      team_item_right_index:2,
      teamItemList:[
        //   {id:1,desc:'1金秋时节总动员，凝心聚力博未来...',src:require('../../assets/images/corporateCulture/culture_five.png'),hidden:false},
        //   {id:2,desc:'2熵达筑梦共发展，携手同心创未来...',src:require('../../assets/images/corporateCulture/culture_six.png'),hidden:false},
        //   {id:3,desc:'3致敬井冈山，熵达向前行...',src:require('../../assets/images/corporateCulture/culture_seven.png'),hidden:false},
        //   {id:4,desc:'4致敬井冈山，熵达向前行...',src:require('../../assets/images/corporateCulture/culture_five.png'),hidden:true},
        //   {id:5,desc:'5致敬井冈山，熵达向前行...',src:require('../../assets/images/corporateCulture/culture_six.png'),hidden:true},
        //   {id:6,desc:'6致敬井冈山，熵达向前行...',src:require('../../assets/images/corporateCulture/culture_seven.png'),hidden:true},
      ],
      corporateCultureCode:'corporate_culture',
      corporateCultureId:0,
      corporateCultureData:'',
    };
  },
  computed: {},
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou entropy Da Trade Co., Ltd',
        'zh-TCC': '廣州市熵達貿易有限公司',
        'zh-CN': '广州市熵达贸易有限公司'
      }
      this.pageTitle = obj[nval]
    },
    'corporateCultureId':function(nval,oval){
      if(nval!=0){
        this.getArticleCorporateCultureByList(1,999);
      }
    },
  },
  mounted(){
    if(this.$store.state.ArticleTypeData){
      let ArticleTypeData=this.$store.state.ArticleTypeData;
      ArticleTypeData.map((v)=>{
        if(v.code==this.corporateCultureCode){
          this.corporateCultureId=v.id
        }
      });
    }
  },
  methods: {
      watchDetail(item){
        this.$router.push({
            path: '/article?id='+item.id
        });
      },
      async getArticleCorporateCultureByList(pageNum,pageSize){
        let resp=await getArticleByTypeList(this.corporateCultureId,pageNum,pageSize);
        if(resp){
            if(resp.data){
                let i=0;
                resp.data.map((v)=>{
                    v.synopsisImg=process.env.BASE_IMG_URL+v.synopsisImg;
                    if(i<4){
                         v.hidden=false;
                    }else{
                        v.hidden=true;
                    }
                    i++;
                })
            }
            this.teamItemList=resp.data;
        }
      },
      getMaxIndex(){
          var maxIndex=0;
          for(var i=0;i<this.teamItemList.length-1;i++){
              if(this.teamItemList[i].hidden==false){
                  if(maxIndex<i){
                    maxIndex=i;
                  }
                  
              }
          }
          return maxIndex;
      },
      getMinIndex(){
        var minIndex=-1;
          for(var i=0;i<this.teamItemList.length-1;i++){
              if(this.teamItemList[i].hidden==false){
                 
                  if(minIndex==-1||minIndex>i){
                      minIndex=i;
                  }
              }
          }
          return minIndex;
      },
      //向左出栈
      leftClick(){
        let origTeamList=this.teamItemList;
        let objNewTeam=[];
        let first=origTeamList[0];
        for(var i=1;i<origTeamList.length;i++){
            objNewTeam.push(origTeamList[i]);
        }
        objNewTeam.push(first);
        for(var j=0;j<objNewTeam.length;j++){
            if(j<4){
                objNewTeam[j].hidden=false;
            }else{
                objNewTeam[j].hidden=true;
            }
        }
        this.teamItemList=objNewTeam;
      },
      //向右出栈
      rightClick(){
        let origTeamList=this.teamItemList;
        let objNewTeam=[];
        let last=origTeamList[origTeamList.length-1];
        objNewTeam.push(last);
        for(var i=0;i<origTeamList.length-1;i++){
            objNewTeam.push(origTeamList[i]);
        }
        
        for(var j=0;j<objNewTeam.length;j++){
            if(j<4){
                objNewTeam[j].hidden=false;
            }else{
                objNewTeam[j].hidden=true;
            }
        }
        this.teamItemList=objNewTeam;
      },
  },
  
  created () {

  },
}
</script>
<style lang='scss' scoped>
.culture_info{
    width:100%;
    background:#fff;
    .culture_content{
        width:70%;
        margin:auto;
        padding:100px 0px; 
        .title_s{
            color: #4f7cbd;
            font-size:40px;
            font-weight: bold;
            cursor: pointer;
        }
        .title_descript{
            margin-top:55px;
            color:#333333;
            font-size: 18px;
            cursor: pointer;
        }
        .culture_team{
            margin-top:83px;
            position: relative;
            .team_content{
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .team_item{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding-left:5px;
                // padding-bottom:25px;
                .item_img{
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .item_desc{
                    width:310px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-top: 18px;
                    font-size: 20px;
                    color: #333333;
                    cursor: pointer;
                }
                .item_detail{
                    margin-top: 25px;
                    width:100%;
                    display: flex;
                    justify-content: center;
                    .detail_btn{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width:120px;
                        height: 43px;
                        border-radius: 22px;
                        border: solid 1px #4f7cbd;
                        color:#4f7cbd;
                        cursor: pointer;
                    }
                    .item_detail_active{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width:120px;
                        height: 43px;
                        border-radius: 22px;
                        border: solid 1px #4f7cbd;
                        background-color: #4f7cbd;
                        color:#fff;
                    }
                    
                    .detail_btn:hover{
                        border: solid 1px #4f7cbd !important;
                        background-color: #4f7cbd !important;
                        color:#fff !important;
                    }
                }
                &:first-child{
                    padding-left: 0px !important;
                }
            }
            .team_item_hidden{
                display:none;
            }

            .arrow_left{
                position: absolute;
                background-color: #4f7cbd;
	            opacity: 0.5;
                color:#fff;
                font-size:30px;
                font-weight: bold;
                border-radius: 50%;
                width: 42px;
                height: 42px;
                top:35%;
                left:-8%;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                span{
                    font-size:22px;
                }
            }
            .arrow_right{
                position: absolute; 
                background-color: #4f7cbd;
	            opacity: 0.5;
                color:#fff;
                font-size:30px;
                font-weight: bold;
                border-radius: 50%;
                top:35%;
                right:-8%;
                cursor: pointer;
                width: 42px;
                height: 42px;
                display: flex;
                justify-content: center;
                align-items: center;
                span{
                    font-size:22px;
                }
            }
            .arrow_left:hover{
                width: 48px;
                height: 48px;
                opacity: 0.8;
                
            }
            .arrow_right:hover{
                width: 48px;
                height: 48px;
                opacity: 0.8;

            }

        }
    }
}


.company_culture_info{
    width:100%;
    background: url('~@/assets/images/corporateCulture/background_one.png') no-repeat;
    background-size: 100% 100%;
    
    .company_culture_content{
        width:70%;
        margin:auto;
        padding:87px 0px 196px 0px; 
        .company_culture_title{
            font-size: 40px;
            font-weight: bold;
            color: #ffffff;
        }
        .company_culture_desc{
            margin-top:60px;
            font-size: 23px;
            font-weight: bold;
            color: #ffffff;
        }
        .company_content_culture{
            margin-top:100px;
            display: flex;
            justify-content: center;
            align-items: center;
            .culture_item{
                background-color: #ffffff;
                margin-left:11px;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-direction: column;
                //  height: 445px;
                // width:292px;
                padding:15px 15px 37px 15px;
                .culture_item_img{
                    img{
                        width:100%;
                        height: 100%;
                    }
                }
                .item_titles{
                    font-size: 22px;
                    font-weight: bold;
                    color:#333333;
                    margin-top:25px;
                    margin-bottom: 23px;
                }
                .item_descs{
                    position: relative;
                    text-align: left;
                    min-width: 213px;
                    font-size: 14px;
                    height: 30px;
                    color:#999999;
                }
                .item_descs:before{
                    content:" ";
                    position:absolute;
                    left:0;
                    top:-10px;
                    width:100%;
                    height:1px;
                    transform:scaleY(.5);
                    background-color:#eeeeee;
                }
            }
        }
    }
}

.eng_company_culture_info{
  
            .culture_item{
                background-color: #ffffff;
                margin-left:11px;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-direction: column;
                min-height: 475px;
                width:392px;
                padding:15px 15px 37px 15px;
                .culture_item_img{
                    img{
                        width:100%;
                        height: 100%;
                    }
                }
                .item_titles{
                    font-size: 22px;
                    font-weight: bold;
                    color:#333333;
                    margin-top:25px;
                    margin-bottom: 23px;
                }
                .item_descs{
                    position: relative;
                    text-align: left;
                    min-width: 213px;
                    font-size: 14px;
                    height: 30px;
                    color:#999999;
                }
                .item_descs:before{
                    content:" ";
                    position:absolute;
                    left:0;
                    top:-10px;
                    width:100%;
                    height:1px;
                    transform:scaleY(.5);
                    background-color:#eeeeee;
                }
            }
     
}

</style>
<style>

</style>


// WEBPACK FOOTER //
// src/view/corporateCulture/index.vue